import cn from 'classnames';
import { useMemo } from 'react';

import { CssQuestionType } from '@webapp/common/components/survey-custom';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import { ABTestingAnswer } from './ab-testing-answer';

import css from './ab-testing.css';

export const ABTesting: FC<SurveyQuestion> = ({ question, readOnly, questionBlockPosition }) => {
    const {
        answersActors,
        params: { ABType },
        selectedAnswerId,
    } = question;
    const answers = useMemo(() => answersActors.map((a) => a.getSnapshot()), [answersActors]);

    return (
        <div
            className={cn(css.abTesting, CssQuestionType.QUESTION, CssQuestionType.AB_TESTING, {
                [css.abTesting_survey]: !readOnly,
            })}
            style={{ textAlign: questionBlockPosition }}
        >
            {answers.map((answer) => {
                if (!readOnly && answer.context.id !== selectedAnswerId) {
                    return null;
                }

                return <ABTestingAnswer answer={answer.context} key={answer.context.id} type={ABType} />;
            })}
        </div>
    );
};
ABTesting.displayName = 'ABTesting';
